import React from "react";
import Hero from "../components/Hero";
import imageBig from "../assets/images/contact-header-big.jpg";
import imageSmall from "../assets/images/contact-header-small.jpg";
import { Box, ContentWrapper } from "../components/Layout";
import colors from "../utils/colors.js";
import styled, { css } from "react-emotion";
import ContactForm from "../components/ContactForm";

const FormStyle = css`
  margin: 0 0 1em 0;
  width: 100%;
`;

const MessageStyle = css`
  width: 100%;
  margin: 0 0 1em 0;
  line-height: 1.6;
  min-height: 250px;
  resize: vertical;
`;

const basicButton = css`
  width: 100%;
  text-align: center;
  padding: 1rem 3rem;
  font-weight: 600;
  transition: all 0.3s ease 0s;
  border: 2px solid ${colors.black};
`;

const primaryButton = css`
  ${basicButton}
  color: white;
  background-color: ${colors.black};

  &:hover {
    cursor: pointer;
    color: ${colors.black};
    background-color: white;
  }
`;


export default ({ data }) => {
  const { social_links } = data.allBusinessJson.edges[0].node;
  return <div>
      <Hero imageBig={imageBig} imageSmall={imageSmall}>
        <Box color="white" p={[3, 3, 4]} align="left">
          <h1>Contact</h1>
        </Box>
      </Hero>
      <Box color={colors.black} p={[3, 3, 4]} align="left">
        <ContentWrapper>
        
          <h2>Need help with Your Data? Get in touch</h2>
< p > PCS never shares your data.</p>
        <ContactForm />
        
          <p>
            If you wanna get in touch, to see how PCS can help with your next
            project and save you money fill out the form below.
          </p>
          <p>Or send us an e-mail to:</p>
          <h4>
            <a href={`mailto:${social_links.email}`}>{social_links.email}</a>
          </h4>
          <p>and call us anytime 877-307-8131</p>
          <br />
        
        </ContentWrapper>
      </Box>
    </div>;
};

export const query = graphql`
  query ContactQuery {
    allBusinessJson {
      edges {
        node {
          social_links {
            email
            phone
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js